// @react
import React, { ReactElement } from 'react'
// @common
// @components
import facets, { Facets, Facet } from '../../config/facets'
// @algolia core
import { connectRefinementList } from 'react-instantsearch-dom'
// @algolia widgets
import Grid from '@bit/atd.web.grid'
import ATDRefinementList from '../Widgets/RefinementList'
import CustomRangeSlider from '../Widgets/RangeSlider'
import ToggleRefinement from '../Widgets/ToggleRefinement'
import { EntityTypes } from '../../config/facets'

// @ts-ignore
const CustomRefinementList = connectRefinementList(ATDRefinementList)

/**********************************
 *  TYPES
 **********************************/
type PropsType = {
  id?: string
  entities: EntityTypes[]
}

const Filters = (props: PropsType) => {
  /**********************************
   *  PROPS
   **********************************/
  const { id, entities } = props
  const index = id || 'master'

  /**********************************
   *  STATE
   **********************************/

  /**
   *
   */
  const getFiltersSets = (): Facets => {
    return facets.reduce((acc: Facets, result) => {
      if (index.startsWith(result.index)) {
        return {
          ...result,
          facets: result.facets.filter((facet: Facet) =>
            facet.allowedEntities.some((entity) => entities.includes(entity)),
          ),
        }
      }
      return acc
    }, facets[0])
  }

  const widgetChooser = (item: Facet) => {
    switch (item.widget) {
      case 'ToggleRefinement':
        return (
          <ToggleRefinement
            attribute={item.facet}
            label={item.label}
            value={true}
            defaultRefinement={false}
          />
        )
      case 'DateRange':
        /* return <DateRange attribute={item.facet} />*/
        return (
          <CustomRefinementList
            limit={5}
            showMore={true}
            showMoreLimit={10}
            attribute={item.facet}
            transformItems={item?.transformItems}
          />
        )
      case 'RangeSlider':
        return (
          <CustomRangeSlider
            attribute={item.facet}
            transformValue={item.transformValue}
          />
        )
      case 'RefinementList':
      default: {
        return (
          <CustomRefinementList
            limit={5}
            showMore={true}
            showMoreLimit={50} // @todo quick request to increase this, do we need to manage it for each filter?
            attribute={item.facet}
            transformItems={item?.transformItems}
          />
        )
      }
    }
  }

  /**
   *
   */
  const filters = (): ReactElement[] => {
    const renderFacetFilter = (item: Facet, index: number): ReactElement => {
      const widget = widgetChooser(item)

      return (
        <div key={`${item.name}_${index}`}>
          <h3>{item.name}</h3>
          {widget}
        </div>
      )
    }

    return getFiltersSets().facets.map(renderFacetFilter)
  }

  /**********************************
   *  RENDER
   **********************************/
  return (
    <>
      {filters().map((el: ReactElement) => {
        return (
          <Grid key={el.key} item>
            {el}
          </Grid>
        )
      })}
    </>
  )
}

export default Filters
